import { API_BASE } from "@/lib/apiBase";

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

const canUsePushNotifications = () => {
  if (window.location.protocol === "http:" && window.location.hostname !== "localhost") {
    console.warn("HTTPS necessario para notificacoes push em producao");
    return false;
  }

  if (!("serviceWorker" in navigator)) {
    console.warn("Service Worker nao suportado");
    return false;
  }

  if (!("PushManager" in window)) {
    console.warn("Push Manager nao suportado");
    return false;
  }

  if (!("Notification" in window)) {
    console.warn("Notificacoes nao suportadas");
    return false;
  }

  if (!VAPID_PUBLIC_KEY) {
    console.warn("REACT_APP_VAPID_PUBLIC_KEY nao configurado");
    return false;
  }

  return true;
};

const getServiceWorkerRegistration = async () => {
  await navigator.serviceWorker.register("/service-worker.js", {
    updateViaCache: "none",
  });

  return navigator.serviceWorker.ready;
};

const subscribeAndSend = async (registration) => {
  const existingSubscription = await registration.pushManager.getSubscription();

  if (existingSubscription) {
    await sendSubscription(existingSubscription);
    return existingSubscription;
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  await sendSubscription(subscription);
  return subscription;
};

export const syncPushNotifications = async () => {
  if (!canUsePushNotifications() || Notification.permission !== "granted") {
    return;
  }

  try {
    const registration = await getServiceWorkerRegistration();
    await subscribeAndSend(registration);
  } catch (error) {
    console.error("Erro ao sincronizar notificacoes:", error);
  }
};

export const registerPushNotifications = async () => {
  if (!canUsePushNotifications()) {
    return;
  }

  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permissao para notificacoes negada");
      return;
    }

    const registration = await getServiceWorkerRegistration();
    await subscribeAndSend(registration);
    console.log("Push notifications configuradas");
  } catch (error) {
    console.error("Erro ao configurar notificacoes:", error);
  }
};

const sendSubscription = async (subscription) => {
  try {
    await fetch(`${API_BASE}/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(subscription),
    });
  } catch (error) {
    console.warn("Falha ao enviar subscription ao backend:", error);
  }
};
